import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

const Charter = () => (
  <div className="ac-about-content-area pt-30 pb-30">
    <Container>
      <Row>
        <Col
          className="wow tpfadeLeft"
          data-wow-duration=".5s"
          data-wow-delay=".7s"
        >
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <Link
              className="text-primary"
              target="_blank"
              download={true}
              to={process.env.PUBLIC_URL + "/assets/docs/MUZFED-TUZUK.pdf"}
              style={{ fontSize: "1.35rem" }}
            >
              Tüzüğü İndirmek İçin Tıklayınız
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
);

export default Charter;
